<template>
  <form ref="form" @submit.prevent="submit">
    <div v-for="(header, index) in editableHeaders" :key="index" class="mb-6">
      <label
        class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
        :for="header.field.name"
      >
        {{ header.title }}
      </label>
      <input
        v-if="header.field.type === 'text'"
        class="appearance-none block w-full bg-gray-200 text-gray-700 border-2 focus:border-blue-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
        :id="header.field.name"
        type="text"
        v-model="form.data[header.field.name]"
      />
      <input
        v-if="header.field.type === 'number'"
        class="appearance-none block w-full bg-gray-200 text-gray-700 border-2 focus:border-blue-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
        :id="header.field.name"
        type="number"
        :min="header.field.min || 1"
        :max="header.field.max || 100"
        v-model="form.data[header.field.name]"
      />
      <Treeselect
        v-else-if="header.field.type === 'select'"
        :multiple="header.field.multiple"
        :async="header.field.async"
        :options="
          header.field.async
            ? []
            : getOptions(
                currentTab.extras[header.field.options],
                header.field.optionName
              )
        "
        :load-options="header.field.async ? header.field.function : null"
        v-model="form.data[header.field.name]"
      />
    </div>
    <div class="flex items-center justify-end pt-4 border-t">
      <button
        class="py-2 px-4 border border-gray-600 hover:bg-indigo-600 hover:text-white hover:border-transparent rounded focus:outline-none"
      >
        Guardar
      </button>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Swal from "sweetalert2";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    Treeselect,
  },
  props: {
    entry: {
      type: Object,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["currentTab"]),
    editableHeaders() {
      return this.currentTab.headers.filter((header) => header.field.editable);
    },
  },
  methods: {
    ...mapMutations(["hideModal"]),
    ...mapActions(["requestEntries"]),
    submit() {
      for (let [key, value] of Object.entries(this.form.data)) {
        if (!Array.isArray(value)) {
          continue;
        }

        this.form.data[key] = value.join();
      }

      axios
        .post("server/index.php", {
          action: this.currentTab.actions.patch,
          ...this.form.data,
        })
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Registro modificado!",
          }).then(() => {
            this.hideModal();
            this.requestEntries();
          });
        });
    },
    getOptions(extras, name) {
      return extras.map((extra) => {
        return { id: extra[name], label: extra[name] };
      });
    },
  },
  created() {
    this.form.action = this.currentTab.actions.post;
    this.form.data = Object.fromEntries(
      this.editableHeaders.map((header) => {
        if (header.field.type === "select") {
          return [
            header.field.name,
            this.entry[header.field.name] === null ||
            this.entry[header.field.name] === ""
              ? []
              : this.entry[header.field.name].split(","),
          ];
        }

        return [header.field.name, this.entry[header.field.name]];
      })
    );
    this.form.data.num = this.entry.num;
    this.form.data.user = this.user.num;
    this.form.data.colegio = this.user.colegio;
  },
  mounted() {
    // autofocus first element
    this.$refs.form.elements[0].focus();
  },
};
</script>
